export class TreatmentTarget extends HTMLElement {
    constructor() {
      super();
    }

    validate() {
      return {};
    }

    isTarget() {
      return true;
    }

    getIcon() {
      return 'fa-question'
    }

    connectedCallback() {
      if(this.querySelector(".remove") != null) {
        this.querySelector(".remove").addEventListener('click', function() {
          if(confirm("Are you sure you want to remove this action and all subsquent?")) {
            $(this).nextAll().remove();
            if(this.closest("post-treatment-flow") != null) {
              this.closest("post-treatment-flow").replace(this);
            } else if(this.closest("treatment-flow") != null) {
              this.closest("treatment-flow").replace(this);
            } else if(this.closest("text-treatment-flow") != null) {
              this.closest("text-treatment-flow").replace(this);
            } else if(this.closest("pbx-treatment-flow") != null) {
              this.closest("pbx-treatment-flow").replace(this);
            }
          }
        }.bind(this));
      }
    }
  }